import { StepperSelectionEvent, STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { DomSanitizer } from '@angular/platform-browser';
// big fat props to https://stackoverflow.com/a/50769855/7618184 !!!!
import { SupportedImportFileTypesConfig } from 'src/config/supported-import-file-types.config';
import { DocxHandler } from '../../classes/docx-handler';
import { FileHandler, IFileHanderParameters } from '../../classes/file-handler.abstract';
import { OdpHandler } from '../../classes/odp-handler';
import { OdtHandler } from '../../classes/odt-handler';
import { PptxHandler } from '../../classes/pptx-handler';
import { PdfHandler } from '../../classes/pdf-handler';
import { MainConfig } from '../../config/main.config';
import { IImageWrapper } from '../../models/image-wrapper';
import { Licenses, LicensesHumanReadable } from '../../models/licenses';
import { SessionServiceService } from '../services/session-service.service';
import { ToastService } from '../services/toast.service';
import { LoggerService } from "../services/logger/logger.service";
import { UI_ACTION_CONSTANTS } from '../services/logger/constants';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { UserConsentBottomSheet } from '../user-consent/user-consent.component';



// using the worker in the node_modules does not work, probably because it can't be accessed


@Component({
  selector: 'app-dialog-import-file',
  templateUrl: './dialog-start.component.html',
  styleUrls: ['./dialog-start.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class DialogStartComponent implements OnInit {
  @ViewChild('stepper', {static: false}) stepper: MatStepper;

  // private _session: SessionServiceService;
  public _session: SessionServiceService;


  public stepperFormGroup: FormGroup;

  private _fileHandler: FileHandler;
  private _images: Promise<IImageWrapper[]>;

  private _loadSearchDatabaseComponent = false;

  public licenses: number[] = [];
  public licensesHumanReadable = LicensesHumanReadable;

  public atWelcome : boolean = true;
  constructor(
    private _dialogRef: MatDialogRef<DialogStartComponent, DialogStartReturnData>,
    @Inject(MAT_DIALOG_DATA) public passedData: DialogStartData,
    private _formBuilder: FormBuilder,
    // private _session: SessionServiceService,
    private _sanitizer: DomSanitizer,
    private _toast: ToastService,
    public session: SessionServiceService,
    private _logger: LoggerService,
    private _userConsentBottomSheet: MatBottomSheet,
  ) {
    this._session = session;
   }

  ngOnInit() {
    this._session = this.passedData.sessionService;
   
    this.stepperFormGroup = new FormGroup({
      chosenFile: new FormControl(null, Validators.required),
      userName: new FormControl('', Validators.required),
      targetLicense: new FormControl(null, Validators.required),
      disclaimerSlideText: new FormControl(null, Validators.required)
    });

    // tslint:disable-next-line:forin
    for (const license in Licenses) {
      const index = Number(license);
      // ignore the 'UNKNOWN' license type
      if (!isNaN(index) && Licenses[index].localeCompare('UNKNOWN') !== 0) {
        this.licenses.push(index);
      }
    }

    // show user consent confirmation bottom sheet if they haven't consented yet
    if (!this._logger.getUserConsent()) {
      this._userConsentBottomSheet.open(UserConsentBottomSheet);
    }

  }

  public async onFileImport(file: FileWrapper): Promise<void> {
    // In general this sort of action could be implemented with a non-blocking progress-indicator/co in the session -> But: Blocks main thread; Thus reverting to block but with message for user
    this._session.awaitAsyncAction("primary",$localize `Loading file...`);
    const _fileHandlerParams: IFileHanderParameters = {file: file, domSanitizer: this._sanitizer};

    // log file type of imported file (.pptx, .docx, .odp, .odt)
    this._session.setFileType(file.type);

    switch (file.type) {
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        this._fileHandler = new PptxHandler(_fileHandlerParams) as PptxHandler;
        break;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        this._fileHandler = new DocxHandler(_fileHandlerParams) as DocxHandler;
        break;
      case 'application/pdf':
        this._fileHandler = new PdfHandler(_fileHandlerParams) as PdfHandler;
        break;
      case 'application/vnd.oasis.opendocument.presentation':
        this._fileHandler = new OdpHandler(_fileHandlerParams);
        break;
        case 'application/vnd.oasis.opendocument.text':
          this._fileHandler = new OdtHandler(_fileHandlerParams);
          break;
      default:
        throw new Error(`File of type '${file.type}' is not supported`);
    }

    this._session.setCurrentGUID(await this._fileHandler.getDocumentGUID());
    this._session.setFileHandler(this._fileHandler);

    this._fileHandler.getImages().then( async (val) => {
      const images: IImageWrapper[] = val;
      this._images = Promise.resolve(images);
      this._session.doneAsyncAction();
      this._session.setCurrentFileAuthor(await this._fileHandler.getFileAuthorName(/*await (this._fileHandler as PptxHandler).getZip()*/));

      // store the number of images in imported file in the session
      this._session.setNoOfImages(images.length);
      // store the mage type in imported file in the session
      for (let i = 0; i < images.length; i++) {
        this._session.incrementImageTypesCount(typeof images[i].base64 === "string" ? "tiff" : images[i].base64.getMimeType().getSubtype());
      }
      // --> Should the logic be in office-open-xml-js.ts instead ??
      // --> Pros of this:
      // -----> 1. Can capture tiff, else this will be converted to png.
      // -----> 2. Can capture unsupported image types
      // --> Cons of this:
      // -----> Doesn't seem right to use services in library assests

      this.stepperFormGroup.get('chosenFile').setValue(file);
      this.stepper.next();
    });
  }

  public onStepChange(event: StepperSelectionEvent) {
    switch (event.previouslySelectedIndex) {
      case 0: {
        // log file imported ui action
        this._logger.log(UI_ACTION_CONSTANTS.FILE_IMPORTED, {
          fileType: this._session.getFileType(),
          noOfImages: this._session.getNoOfImages(),
          noOfImageTypes: this._session.getNoOfImageTypesCount(),
        });
        break;
      }
      case 1: {
        // log enter name ui action
        this._logger.log(UI_ACTION_CONSTANTS.USERNAME_ENTERED);
        break;
      }
      case 2: {
        // store th target License in session
        this._session.setTargetLicense(this.stepperFormGroup.get('targetLicense').value);
        // log enter target license ui action
        this._logger.log(UI_ACTION_CONSTANTS.TARGET_LICENSE_SELECTED, {
          targetLicense: this.getLicenseShortName(this.stepperFormGroup.get('targetLicense').value)
        });
        break;
      }
      case 3: {
        // log enter legal disclaimer ui action
        this._logger.log(UI_ACTION_CONSTANTS.LEGAL_DISCLAIMER_ENTERED);
        break;
      }
      default:
        break;
    }

    switch (event.selectedStep.state) {
      case 'enterLegalText':
        this.processAndUpdateDisclaimerTextTemplate();
        break;
    }
  }

  public processAndUpdateDisclaimerTextTemplate(): void {
    const processedText = MainConfig.disclaimerSlide.defaultText
      .replace('__ORIGINAL_AUTHOR__', this._session.getCurrentFileAuthor())
      .replace('__TOOL_NAME__', this._session.getToolName)
      .replace('__USER_NAME__', this.stepperFormGroup.get('userName').value.toString())
      // if i don't bind the _session, the 'this' is not defined and throws an error
      .replace('__TOOL_VERSION__', this._session.getCurrentToolVersion.bind(this._session))
      .replace('__LICENSE_FULL_NAME__', this.getLicenseFullName(this.stepperFormGroup.get('targetLicense').value))
      .replace('__LICENSE_SHORT_NAME__', this.getLicenseShortName(this.stepperFormGroup.get('targetLicense').value))
    ;
    this.stepperFormGroup.get('disclaimerSlideText').setValue(processedText);
  }

  // *********************************
  // *** All Formats available for use ****
  public getAllFileFormats(): string {
    return SupportedImportFileTypesConfig.map((v) => "." + v.extension).join(', ');
  }
  // *********************************

  public getLicenseFullName(license: Licenses): string {
    switch (license) {
      case 1:
        return 'CC-0 1.0 Universal, Public Domain Dedication';
      case 2:
        return 'Attribution 4.0 International';
      case 3:
        return 'Attribution-ShareAlike 4.0 International';
    }
  }

  public getLicenseShortName(license: Licenses): string {
    switch (license) {
      case 1:
        return 'CC-0 1.0';
      case 2:
        return 'CC-BY 4.0';
      case 3:
        return 'CC-BY-SA 4.0';
    }
  }

  public getLicenseURL(license: Licenses): string {
    switch (license) {
      case 1:
        return 'https://creativecommons.org/publicdomain/zero/1.0/';
      case 2:
        return 'https://creativecommons.org/licenses/by/4.0/';
      case 3:
        return 'https://creativecommons.org/licenses/by-sa/4.0/';
    }
  }

  public async closeStartDialog(): Promise<void> {
    this.processAllInputData();

    this._dialogRef.close({
      fileHandler: this._fileHandler,
      images: await this._images
    });
  }

  public processAllInputData(): void {
    // just to be 100% sure that all the input data will be processed
    this._session.setCurrentUserRealName(this.stepperFormGroup.get('userName').value.toString());
    this._session.setTargetLicense(this.stepperFormGroup.get('targetLicense').value);
    // maybe the next line is only needed until the two extra steps are working again, I don't know for sure
    this._session.setLegalDisclaimerText(this.stepperFormGroup.get('disclaimerSlideText').value.toString());
    // this.processAndUpdateDisclaimerTextTemplate();
    // this._session.setLegalDisclaimerText(this.stepperFormGroup.get('disclaimerSlideText').value.toString());
  }


  public async processAdditionalOptions(autoClassifyImages: boolean){
      this._session.awaitAsyncAction("primary", $localize `Loading classifier model...`);
      await this._session.setAutoClassifyImages(autoClassifyImages);
      this._session.doneAsyncAction();

      // log additional options ui action
      this._logger.log(UI_ACTION_CONSTANTS.FIRST_STEPS_DIALOG_FINISHED, {
        autoClassifyImages: autoClassifyImages,
      });

      this.closeStartDialog();
  }
  public changeLanguageVersion(locale: string){
    location.href = '/'+locale;
  }
}

export interface DialogStartData {
  // I don't know why, but injecting the service the usual way results in error when getting the tools version.
  sessionService: SessionServiceService;
}

export interface DialogStartReturnData {
  fileHandler: FileHandler;
  images: IImageWrapper[];
}
